{
  "apps.bi.barChart.empty": "No stores registered yet",
  "apps.bi.funnel.lost": "Lost: {count} deals · {value}",
  "apps.bi.funnel.lostOne": "Lost: 1 deal · {value}",
  "apps.bi.stage.lead": "Lead",
  "apps.bi.stage.lost": "Lost",
  "apps.bi.stage.proposal": "Proposal",
  "apps.bi.stage.qualified": "Qualified",
  "apps.bi.stage.won": "Won",
  "apps.catalog.agtCodeReviewer.descr": "Independent reviewer agent with read-only access.",
  "apps.catalog.agtCodeReviewer.name": "Code Reviewer",
  "apps.catalog.agtDocsWriter.descr": "Drafts API + README docs from real code, not vibes.",
  "apps.catalog.agtDocsWriter.name": "Docs Writer",
  "apps.catalog.agtRefactor.descr": "Plans a multi-file refactor before touching anything.",
  "apps.catalog.agtRefactor.name": "Refactor Agent",
  "apps.catalog.agtSecurityAuditor.descr": "Hunts OWASP Top-10 + auth/authz bugs in the diff.",
  "apps.catalog.agtSecurityAuditor.name": "Security Auditor",
  "apps.catalog.agtTestWriter.descr": "Writes failing tests first, then watches them turn green.",
  "apps.catalog.agtTestWriter.name": "Test Writer",
  "apps.catalog.mcpSymbols.descr": "Symbols' own MCP server — projects, tickets, workspace tools.",
  "apps.catalog.plgA11y.descr": "WCAG checks in editor.",
  "apps.catalog.plgA11y.name": "Accessibility Audit",
  "apps.catalog.plgGridstack.descr": "Drag-and-drop grid layouts.",
  "apps.catalog.plgGridstack.name": "Gridstack Layout",
  "apps.catalog.plgI18n.descr": "Multi-language content.",
  "apps.catalog.plgMonaco.descr": "In-browser code editing.",
  "apps.catalog.plgSeo.descr": "Meta tags, sitemaps, OG images.",
  "apps.catalog.plgSeo.name": "SEO Tools",
  "apps.catalog.prmApiDesign.descr": "Critique an API surface for consistency and longevity.",
  "apps.catalog.prmApiDesign.name": "API Design Review",
  "apps.catalog.prmBugRca.descr": "Investigate a bug report and propose a minimal fix + test.",
  "apps.catalog.prmBugRca.name": "Bug Root-Cause",
  "apps.catalog.prmCodeReview.descr": "Walk a diff for correctness, style, security, and tests.",
  "apps.catalog.prmCodeReview.name": "Code Review",
  "apps.catalog.prmCommitMsg.descr": "Compose a focused commit message from a staged diff.",
  "apps.catalog.prmCommitMsg.name": "Commit Message",
  "apps.catalog.prmPrdDraft.descr": "Turn raw notes into a tight one-page PRD.",
  "apps.catalog.prmPrdDraft.name": "PRD Draft",
  "apps.catalog.regCloudflareRegistrar.descr": "At-cost domain registration with built-in DNS.",
  "apps.catalog.regGandi.descr": "Domains, DNS, and mailbox hosting.",
  "apps.catalog.regGodaddy.descr": "Domain search, registration, transfers, DNS.",
  "apps.catalog.regHover.descr": "Domains, email forwarding, and DNS without upsells.",
  "apps.catalog.regName.descr": "Domains, DNS, and SSL with a developer API.",
  "apps.catalog.regNamecheap.descr": "Register and manage domains with WHOIS privacy.",
  "apps.catalog.regNamesilo.descr": "Low-cost domains with free privacy and API access.",
  "apps.catalog.regPorkbun.descr": "Developer-friendly registrar with free WHOIS privacy.",
  "apps.catalog.regSquarespaceDomains.descr": "Domains, DNS, and forwarding (formerly Google Domains).",
  "apps.catalog.sklInit.descr": "Generate a CLAUDE.md from the codebase.",
  "apps.catalog.sklLoop.descr": "Re-run a prompt on a recurring interval.",
  "apps.catalog.sklReview.descr": "Review a PR or branch end-to-end.",
  "apps.catalog.sklSchedule.descr": "Schedule remote agents on cron.",
  "apps.catalog.sklSecurityReview.descr": "Run a security pass on pending changes.",
  "apps.catalog.sklSimplify.descr": "Audit pending changes for over-engineering.",
  "apps.catalog.trigger.onRequest": "On request — {cmd}",
  "apps.cms.status.draft": "draft",
  "apps.cms.status.published": "published",
  "apps.commerce.invoiceStatus.draft": "Draft",
  "apps.commerce.invoiceStatus.overdue": "Overdue",
  "apps.commerce.invoiceStatus.paid": "Paid",
  "apps.commerce.invoiceStatus.partiallyPaid": "Partially Paid",
  "apps.commerce.invoiceStatus.sent": "Sent",
  "apps.commerce.invoiceStatus.unpaid": "Unpaid",
  "apps.commerce.invoiceStatus.void": "Void",
  "apps.commerce.party.none": "No customer",
  "apps.commerce.party.unknown": "Customer",
  "apps.crm.contact.unnamed": "Contact",
  "apps.crm.followup.untitled": "Follow-up",
  "apps.crm.kind.call": "Call",
  "apps.crm.kind.email": "Email",
  "apps.crm.kind.meeting": "Meeting",
  "apps.crm.kind.note": "Note",
  "apps.crm.kind.task": "Task",
  "apps.crm.stage.lead": "Lead",
  "apps.crm.stage.lost": "Lost",
  "apps.crm.stage.proposal": "Proposal",
  "apps.crm.stage.qualified": "Qualified",
  "apps.crm.stage.won": "Won",
  "apps.crm.when.dueToday": "Due today",
  "apps.crm.when.dueTomorrow": "Due tomorrow",
  "apps.crm.when.inDays": "In {count}d",
  "apps.crm.when.overdue": "{count}d overdue",
  "apps.helmet.stat.ai": "AI-ready",
  "apps.helmet.stat.issues": "Issues",
  "apps.helmet.stat.pages": "Pages",
  "apps.helmet.stat.score": "Avg score",
  "apps.hr.leaveKind.sick": "Sick",
  "apps.hr.leaveKind.unpaid": "Unpaid",
  "apps.hr.leaveKind.vacation": "Vacation",
  "apps.hr.person.unnamed": "Someone",
  "apps.hr.role.cashier": "Cashier",
  "apps.hr.role.ceo": "CEO",
  "apps.hr.role.manager": "Manager",
  "apps.hr.role.other": "Other",
  "apps.hr.role.warehouseManager": "Warehouse manager",
  "apps.installModal.domain": "Domain: {domain}",
  "apps.installModal.install": "Install",
  "apps.installModal.installItem": "Install {item}",
  "apps.installModal.manageItem": "Manage {item}",
  "apps.installModal.scope": "Scope: {scope}",
  "apps.installStub.comingSoon": "Phase 4 — MarketplaceInstallModal coming soon",
  "apps.installStub.dismiss": "Dismiss",
  "apps.installStub.receivedArgs": "RECEIVED ARGS",
  "apps.integration.amplitude.descr": "Add Amplitude analytics to your website",
  "apps.integration.auth0.descr": "Connect authorisation to your app",
  "apps.integration.connect": "Connect",
  "apps.integration.connectFailed": "Connect failed",
  "apps.integration.connectKind": "Connect {kind}",
  "apps.integration.connected": "Connected {name}",
  "apps.integration.connecting": "Connecting…",
  "apps.integration.custom.descr": "Add custom endpoint as data source",
  "apps.integration.custom.title": "Custom",
  "apps.integration.disconnected": "Disconnected",
  "apps.integration.displayName": "Display name",
  "apps.integration.displayNamePlaceholder": "My integration",
  "apps.integration.firebase.descr": "Connect to Firebase endpoint",
  "apps.integration.github.descr": "Connect repository and sync changes",
  "apps.integration.googleAnalytics.descr": "Collect data to your Google Tag dashboard",
  "apps.integration.googleSheets.descr": "Connect sheets as data source",
  "apps.integration.instagram.descr": "Import instagram feed as data",
  "apps.integration.intercom.descr": "Add live support on your website",
  "apps.integration.missingField.message": "\"{field}\" is required.",
  "apps.integration.missingField.title": "Missing required field",
  "apps.integration.noWorkspace": "No active workspace",
  "apps.integration.npm.descr": "Publish your project as NPM package",
  "apps.integration.removeFailed": "Remove failed",
  "apps.integration.reorderFailed": "Reorder save failed",
  "apps.integration.scopeRequired.message": "Select or enter a {scope} ID.",
  "apps.integration.scopeRequired.title": "Scope ID required",
  "apps.integration.secretLabel": "API key / Secret",
  "apps.integration.serverError": "Server error",
  "apps.integration.slack.descr": "Get notifications on important events",
  "apps.integration.status.disabled": "Disabled",
  "apps.integration.status.live": "Live",
  "apps.integration.stripe.descr": "Connect your Stripe payments to your app",
  "apps.integration.test": "Test",
  "apps.integration.testFailed": "Test failed",
  "apps.integration.testPassed": "Test passed ✓",
  "apps.integration.testing": "Testing…",
  "apps.integration.unknownError": "Unknown error",
  "apps.integrations.title": "INTEGRATIONS",
  "apps.jobs.stage.hired": "Hired",
  "apps.jobs.stage.interview": "Interview",
  "apps.jobs.stage.new": "New",
  "apps.jobs.stage.offer": "Offer",
  "apps.jobs.stage.rejected": "Rejected",
  "apps.jobs.stage.screening": "Screening",
  "apps.jobs.stage.withdrawn": "Withdrawn",
  "apps.mcp.field.authKind": "Auth kind (none, bearer, api-key, oauth)",
  "apps.mcp.field.authToken": "Auth token (bearer / api-key only)",
  "apps.mcp.field.transport": "Transport (sse, websocket, http)",
  "apps.mcp.field.url": "Server URL",
  "apps.policies.holder.unnamed": "Unnamed holder",
  "apps.policies.renewal.inDays": "in {count}d",
  "apps.policies.renewal.overdue": "{count}d overdue",
  "apps.policies.renewal.today": "Today",
  "apps.rail.add": "Add {domain}",
  "apps.rail.available": "Available",
  "apps.rail.empty.title": "Add your first {domain}",
  "apps.rail.emptyHint.org": "No {domain} installed for this organization yet.",
  "apps.rail.emptyHint.project": "No {domain} installed for this project yet.",
  "apps.rail.emptyHint.workspace": "No {domain} installed for this workspace yet.",
  "apps.rail.error.load": "Load failed",
  "apps.rail.error.loadInstalled": "Failed to load installed items",
  "apps.rail.installed": "Installed",
  "apps.scheduling.kind.booking": "Booking",
  "apps.scheduling.role.cashier": "Cashier",
  "apps.scheduling.role.manager": "Manager",
  "apps.scheduling.role.warehouse": "Warehouse",
  "apps.scheduling.staff.unnamed": "Staff",
  "apps.scheduling.status.booked": "Booked",
  "apps.scheduling.status.cancelled": "Cancelled",
  "apps.scheduling.status.completed": "Completed",
  "apps.scheduling.status.confirmed": "Confirmed",
  "apps.scheduling.status.delivered": "Delivered",
  "apps.scheduling.status.noShow": "No Show",
  "apps.scheduling.status.pending": "Pending",
  "apps.scheduling.time.none": "No time",
  "apps.scheduling.time.notSet": "No time set",
  "apps.scope.error.fetchFailed": "Fetch failed",
  "apps.scope.error.rateLimited": "Rate limited",
  "apps.scope.error.sessionNotLoaded": "Session not loaded",
  "apps.scope.hint": "Org-wide infra (SSO, code) should stay at org scope. Per-product integrations (databases, analytics) are best scoped to a project so the editor only surfaces them inside that project.",
  "apps.scope.loadingProjects": "Loading projects…",
  "apps.scope.mode.org": "Org",
  "apps.scope.mode.project": "Project",
  "apps.scope.mode.workspace": "Workspace",
  "apps.scope.noMatches": "No matches for \"{query}\".",
  "apps.scope.proj.backToList": "← Back to list",
  "apps.scope.proj.empty": "No projects found.",
  "apps.scope.proj.emptyOrg": "No projects in this org.",
  "apps.scope.proj.loadFailed": "Could not load projects: {error}",
  "apps.scope.proj.manualEntry": "+ Enter project ID manually",
  "apps.scope.projectId": "Project ID",
  "apps.scope.searchProjects": "Search projects…",
  "apps.scope.searchWorkspaces": "Search workspaces…",
  "apps.scope.selected": "Selected: {name}",
  "apps.scope.title": "Scope",
  "apps.scope.ws.empty": "No workspaces found.",
  "apps.scope.ws.emptyOrg": "No workspaces in this org.",
  "apps.warehouse.moveType.adjustment": "adjustment",
  "apps.warehouse.moveType.count": "count",
  "apps.warehouse.moveType.receipt": "receipt",
  "apps.warehouse.moveType.return": "return",
  "apps.warehouse.moveType.sale": "sale",
  "apps.warehouse.moveType.transferIn": "transfer in",
  "apps.warehouse.moveType.transferOut": "transfer out",
  "apps.warehouse.moveType.writeOff": "write off",
  "apps.warehouse.product.unknown": "(unknown product)",
  "apps.warehouse.timeAgo.days": "{count}d ago",
  "apps.warehouse.timeAgo.hours": "{count}h ago",
  "apps.warehouse.timeAgo.minutes": "{count}m ago",
  "apps.warehouse.timeAgo.now": "now",
  "apps.widget.biPipeline.caption": "Open pipeline · lead + qualified + proposal",
  "apps.widget.biPipeline.captionMini": "open pipeline",
  "apps.widget.biPipeline.empty": "No deals yet",
  "apps.widget.biPipeline.title": "Pipeline",
  "apps.widget.biPipeline.unit": "open",
  "apps.widget.biPipeline.wonRate": "{rate}% won",
  "apps.widget.biRevenue.caption": "Today across stores · 7-day trend",
  "apps.widget.biRevenue.captionMini": "today's revenue",
  "apps.widget.biRevenue.empty": "No sales recorded yet",
  "apps.widget.biRevenue.footer": "All stores",
  "apps.widget.biRevenue.title": "Revenue",
  "apps.widget.biRevenue.window": "· {count}d",
  "apps.widget.biStock.caption": "stock health",
  "apps.widget.biStock.empty": "No stock on shelf yet",
  "apps.widget.biStock.lowAlerts": "{count} low-stock alerts",
  "apps.widget.biStock.lowAlertsOne": "1 low-stock alert",
  "apps.widget.biStock.nothingBelow": "Nothing below threshold",
  "apps.widget.biStock.title": "Stock",
  "apps.widget.biStock.unit": "healthy",
  "apps.widget.biStores.caption": "Revenue by store · last {count} days",
  "apps.widget.biStores.captionMini": "stores reporting",
  "apps.widget.biStores.empty": "No store sales in this period",
  "apps.widget.biStores.footer": "Last {count} days",
  "apps.widget.biStores.title": "Stores",
  "apps.widget.bookmarksRecent.empty": "No saved bookmarks yet",
  "apps.widget.bookmarksRecent.title": "Recent bookmarks",
  "apps.widget.bookmarksRecent.unit": "bookmarks saved",
  "apps.widget.bookmarksRecent.unitOne": "bookmark saved",
  "apps.widget.capTable.captionMini": "cap table holders",
  "apps.widget.capTable.empty": "No grants yet",
  "apps.widget.capTable.title": "Cap table",
  "apps.widget.cmsRecent.empty": "No entries yet",
  "apps.widget.cmsRecent.title": "Content",
  "apps.widget.cmsRecent.unit": "entries",
  "apps.widget.cmsRecent.unitOne": "entry",
  "apps.widget.crmFollowups.error": "Couldn't load follow-ups",
  "apps.widget.crmFollowups.title": "Follow-ups",
  "apps.widget.crmPipeline.error": "Couldn't load the pipeline",
  "apps.widget.crmPipeline.title": "Pipeline",
  "apps.widget.crmRecent.empty": "No contacts yet",
  "apps.widget.crmRecent.error": "Couldn't load contacts",
  "apps.widget.crmRecent.title": "Recent contacts",
  "apps.widget.crmRecent.unit": "contacts",
  "apps.widget.crmRecent.unitOne": "contact",
  "apps.widget.helmetHealth.caption": "avg score",
  "apps.widget.helmetHealth.captionMini": "avg SEO score",
  "apps.widget.helmetHealth.empty": "No pages yet",
  "apps.widget.helmetHealth.title": "SEO health",
  "apps.widget.hrHeadcount.empty": "No team members yet",
  "apps.widget.hrHeadcount.title": "Headcount",
  "apps.widget.hrHeadcount.unit": "people",
  "apps.widget.hrHeadcount.unitOne": "person",
  "apps.widget.hrLeaveToday.caption": "out this week",
  "apps.widget.hrLeaveToday.empty": "Nobody is out this week",
  "apps.widget.hrLeaveToday.title": "Out of office",
  "apps.widget.hrLeaveToday.unit": "out",
  "apps.widget.hrOnboarding.caption": "in progress",
  "apps.widget.hrOnboarding.captionMini": "onboarding in progress",
  "apps.widget.hrOnboarding.empty": "No onboardings in progress",
  "apps.widget.hrOnboarding.title": "Onboarding",
  "apps.widget.hrRecent.captionMini": "on the team",
  "apps.widget.hrRecent.empty": "No team members yet",
  "apps.widget.hrRecent.title": "Team",
  "apps.widget.hrRecent.unit": "team members",
  "apps.widget.hrRecent.unitOne": "team member",
  "apps.widget.jobsPipeline.caption": "open applications",
  "apps.widget.jobsPipeline.empty": "No applications yet — open Hiring to review the pipeline",
  "apps.widget.jobsPipeline.error": "Couldn't load the pipeline",
  "apps.widget.jobsPipeline.title": "Hiring pipeline",
  "apps.widget.policiesRenewals.captionMini": "renewals need attention",
  "apps.widget.policiesRenewals.empty": "No upcoming renewals",
  "apps.widget.policiesRenewals.title": "Upcoming renewals",
  "apps.widget.polyglotCoverage.captionMini": "avg coverage",
  "apps.widget.polyglotCoverage.complete": "Complete",
  "apps.widget.polyglotCoverage.empty": "No locales yet",
  "apps.widget.polyglotCoverage.missing": "{count} missing",
  "apps.widget.polyglotCoverage.title": "Translations",
  "apps.widget.schUpcoming.caption": "bookings ahead",
  "apps.widget.schUpcoming.empty": "No upcoming bookings",
  "apps.widget.schUpcoming.title": "Upcoming bookings",
  "apps.widget.schedToday.caption": "on the schedule",
  "apps.widget.schedToday.empty": "Nothing scheduled today",
  "apps.widget.schedToday.title": "Today",
  "apps.widget.schedWeek.caption": "entries this week",
  "apps.widget.schedWeek.dayTooltip": "{bookings} bookings · {shifts} shifts",
  "apps.widget.schedWeek.empty": "A quiet week",
  "apps.widget.schedWeek.legendBookings": "Bookings",
  "apps.widget.schedWeek.legendShifts": "Shifts",
  "apps.widget.schedWeek.title": "This week",
  "apps.widget.schedWeek.unit": "bookings",
  "apps.widget.storeRevenueToday.captionMini": "today's revenue",
  "apps.widget.storeRevenueToday.empty": "Add store locations to see per-store revenue.",
  "apps.widget.storeRevenueToday.entriesToday": "{count} entries today",
  "apps.widget.storeRevenueToday.entriesTodayOne": "1 entry today",
  "apps.widget.storeRevenueToday.noSales": "No sales recorded today",
  "apps.widget.storeRevenueToday.title": "Today's revenue",
  "apps.widget.storeRevenueToday.txCount": "{count} tx",
  "apps.widget.storeRevenueToday.unit": "today",
  "apps.widget.storeUnpaid.empty": "Nothing unpaid — all settled.",
  "apps.widget.storeUnpaid.stillDue": "still due across {count} invoices",
  "apps.widget.storeUnpaid.stillDueOne": "still due across 1 invoice",
  "apps.widget.storeUnpaid.title": "Unpaid invoices",
  "apps.widget.storeUnpaid.unit": "unpaid invoices",
  "apps.widget.storeUnpaid.unitOne": "unpaid invoice",
  "apps.widget.storeUnpaid.unitShort": "unpaid",
  "apps.widget.whLowstock.avail": "{count} avail",
  "apps.widget.whLowstock.caption": "products low or out",
  "apps.widget.whLowstock.captionMini": "low or out",
  "apps.widget.whLowstock.empty": "All stocked up — nothing low or out.",
  "apps.widget.whLowstock.outCount": "{count} out",
  "apps.widget.whLowstock.title": "Low stock",
  "apps.widget.whMoves.caption": "movements logged",
  "apps.widget.whMoves.empty": "No movements yet",
  "apps.widget.whMoves.footer": "Last move {when}",
  "apps.widget.whMoves.title": "Movements",
  "apps.widget.whMoves.unitToday": "today",
  "apps.widget.whStock.availableOf": "available of {count} on shelf",
  "apps.widget.whStock.captionMini": "units available",
  "apps.widget.whStock.empty": "No warehouses yet",
  "apps.widget.whStock.footer": "{count} warehouses",
  "apps.widget.whStock.footerOne": "1 warehouse",
  "apps.widget.whStock.lowProducts": "{count} products low or out",
  "apps.widget.whStock.lowProductsOne": "1 product low or out",
  "apps.widget.whStock.title": "Warehouse stock"
}
